module.exports = __webpack_public_path__ + "img/ai.9db3f9fa.png";